<template>
    <div class="main-tabs" style="border:none;" v-cloak>
        <ul>
            <li :class="{ active: active_sub_tab == 'tasks' }" @click="set_active_tab('tasks')">
                <a href="javascript:{}"
                    >Tasks
                    <span>
                        <span
                            style="margin-left:0;"
                            :class="{
                                'done-span': done_items && done_items.length > 0
                            }"
                            >{{ done_items.length }}</span
                        >/{{ event.tasks.length }}</span
                    >
                    <span
                        v-if="deadline_items && deadline_items.length > 0"
                        style="margin-left:0;"
                        class="tasks-alert"
                        >{{ deadline_items.length }}</span
                    >
                </a>
            </li>
            <li :class="{ active: active_sub_tab == 'guests' }" @click="set_active_tab('guests')">
                <a href="javascript:{}"
                    >Guests
                    <span>
                        <span
                            style="margin-left:0;"
                            :class="{
                                'done-span': attending_total && attending_total.length > 0
                            }"
                            >{{ attending_total.length }}</span
                        ><span style="margin-left:0;" v-if="event.guests">/{{ event.guests.length }}</span></span
                    >
                </a>
            </li>
            <!--<li :class="{ active: active_tab == 'menu' }" @click="set_active_tab('menu')">
                <a href="javascript:{}">Menu <span>1/2</span></a>
            </li> -->
            <!--<li>
                <a href="javascript:{}"
                >Expenses <span>3/5</span></a
                >
            </li>
            -->
        </ul>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import moment from "moment";
import router from "@/router";

export default {
    name: "event-submenu",
    data() {
        this.set_active_tab("menu");
        if (this.$route.name === "event-guests") {
            this.set_active_tab("guests");
        }
        if (this.$route.name === "event") {
            this.set_active_tab("tasks");
        }
        return {};
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.set_active_sub_tab("tasks");
            next();
        });
    },
    computed: {
        ...mapState("StoreEvent", ["event", "active_sub_tab"]),
        ...mapState("StoreEvent", ["event_task"]),
        ...mapState("StoreEvent", ["task_event_save_btn_disabled"]),
        ...mapState("StoreEvent", ["global_errors"]),
        ...mapGetters("StoreEvent", ["attending_total"]),
        deadline_items() {
            if (this.event.tasks && this.event.tasks.length > 0) {
                return this.event.tasks.filter(item => {
                    return (
                        item.status === "in_progress" &&
                        item.deadline &&
                        moment(item.deadline).format("DD.MM") === moment(new Date()).format("DD.MM")
                    );
                });
            } else {
                return [];
            }
        },
        done_items() {
            if (this.event.tasks && this.event.tasks.length > 0) {
                return this.event.tasks.filter(item => {
                    return item.status === "done";
                });
            } else {
                return [];
            }
        }
    },
    methods: {
        ...mapMutations("StoreEvent", ["set_active_sub_tab"]),
        set_active_tab(tab) {
            if (tab === this.active_sub_tab) {
                return;
            }
            this.set_active_sub_tab(tab);
            if (tab === "guests" && this.event) {
                if (this.event.id) {
                    router.push({ path: "/events/" + this.event.id + "/guests" });
                }
            }
            if (tab === "tasks" && this.event) {
                if (this.event.id) {
                    router.push({ path: "/events/" + this.event.id });
                }
            }
        }
    }
};
</script>

<style scoped></style>
